/** When true, Photoslop compose UI does not gate Create on token balance. */
export function photoslopBypassTokens() {
  if (process.env.REACT_APP_PHOTOSLOP_BYPASS_TOKENS === 'true') return true;
  if (process.env.REACT_APP_PHOTOSLOP_BYPASS_TOKENS === 'false') return false;
  return process.env.NODE_ENV === 'development';
}
